import { useMemo } from 'react';
import { useBrokerIsExternal } from '@/common/hooks/useBrokerIsExternal';
import { GLOSSARY_DEFINITIONS } from './constants';

const SIDE_ONLY_TERMS = new Set([
  'Side Split %',
  'Side Gross',
  'Side Net Fees',
  'Side Net Commission',
]);

export function useGlossaryDefinitions() {
  const { isExternal } = useBrokerIsExternal();

  return useMemo(() => {
    if (!isExternal) {
      return GLOSSARY_DEFINITIONS;
    }

    return GLOSSARY_DEFINITIONS.map(({ category, items }) => ({
      category,
      items: items.filter(({ title }) => !SIDE_ONLY_TERMS.has(title)),
    })).filter(({ items }) => items.length > 0);
  }, [isExternal]);
}
